var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ChangeWorldMessage } from "flavr-common";
import { sessionPermissionsService } from "../services/SessionPermissionsService";
import { scriptService } from "../services/ScriptService";
export class ScriptSession {
    static isModerator() {
        return sessionPermissionsService.hasPermission("mod");
    }
    // ToDo: moved to room
    static isHost() {
        if (!scriptService.context)
            return false;
        return scriptService.context.isRoomHost;
    }
    static loadWorld(worldId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scriptService.context)
                return false;
            scriptService.context.flushMessages();
            scriptService.context.connection.send(new ChangeWorldMessage(worldId));
            return true;
        });
    }
}
